export class SellerModel {
  sellerId: number;
  sellerName: string;
  sellerDescription: string;
  logo: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  postcode: string;
  country: string;
  email: string;
  countryCode: string;
  contactNumber: string;
  businessName: string;
  shippingPolicy: string;
  returnPolicy: string;
  paymentMethods: PaymentMethod[];
  paymentTerms: string;

  constructor(seller: any) {
    this.sellerId = seller.sellerId;
    this.sellerName = seller.sellerName;
    this.sellerDescription = seller.sellerDescription;
    this.logo = seller.logo;
    this.addressLine1 = seller.addressLine1;
    this.addressLine2 = seller.addressLine2;
    this.city = seller.city;
    this.state = seller.state;
    this.postcode = seller.postcode;
    this.country = seller.country;
    this.email = seller.email;
    this.countryCode = seller.countryCode ?? '';
    this.contactNumber = seller.contactNumber;
    this.businessName = seller.businessName ?? '';

    this.shippingPolicy = seller.shippingPolicy ?? '';
    this.returnPolicy = seller.returnPolicy ?? '';
    this.paymentTerms = seller.paymentTerms ?? '';
    this.paymentMethods = Array.isArray(seller.paymentMethods)
      ? seller.paymentMethods.map((pm: any) => ({
        paymentMethodId: pm.paymentMethodId,
        name: pm.name,
        iconImage: pm.iconImage,
      }))
      : [];
  }
}


export interface PaymentMethod {
  paymentMethodId: number;
  name: string;
  iconImage: string;
}

